import md5 from 'js-md5';
import Vue from 'vue';
import {
  Toast
} from 'vant';
Vue.use(Toast);
Vue.prototype.$toast = Toast;
/*! layer mobile-v2.0.0 Web弹层组件 MIT License  http://layer.layui.com/mobile  By 贤心 */
;
! function (e) {
  "use strict";
  var t = document,
    n = "querySelectorAll",
    i = "getElementsByClassName",
    a = function (e) {
      return t[n](e)
    },
    s = {
      type: 0,
      shade: !0,
      shadeClose: !0,
      fixed: !0,
      anim: "scale"
    },
    l = {
      extend: function (e) {
        var t = JSON.parse(JSON.stringify(s));
        for (var n in e) t[n] = e[n];
        return t
      },
      timer: {},
      end: {}
    };
  l.touch = function (e, t) {
    e.addEventListener("click", function (e) {
      t.call(this, e)
    }, !1)
  };
  var r = 0,
    o = ["layui-m-layer"],
    c = function (e) {
      var t = this;
      t.config = l.extend(e), t.view()
    };
  c.prototype.view = function () {
    var e = this,
      n = e.config,
      s = t.createElement("div");
    e.id = s.id = o[0] + r, s.setAttribute("class", o[0] + " " + o[0] + (n.type || 0)), s.setAttribute("index", r);
    var l = function () {
        var e = "object" == typeof n.title;
        return n.title ? '<h3 style="' + (e ? n.title[1] : "") + '">' + (e ? n.title[0] : n.title) + "</h3>" : ""
      }(),
      c = function () {
        "string" == typeof n.btn && (n.btn = [n.btn]);
        var e, t = (n.btn || []).length;
        return 0 !== t && n.btn ? (e = '<span yes type="1">' + n.btn[0] + "</span>", 2 === t && (e = '<span no type="0">' + n.btn[1] + "</span>" + e), '<div class="layui-m-layerbtn">' + e + "</div>") : ""
      }();
    if (n.fixed || (n.top = n.hasOwnProperty("top") ? n.top : 100, n.style = n.style || "", n.style += " top:" + (t.body.scrollTop + n.top) + "px"), 2 === n.type && (n.content = '<i></i><i class="layui-m-layerload"></i><i></i><p>' + (n.content || "") + "</p>"), n.skin && (n.anim = "up"), "msg" === n.skin && (n.shade = !1), s.innerHTML = (n.shade ? "<div " + ("string" == typeof n.shade ? 'style="' + n.shade + '"' : "") + ' class="layui-m-layershade"></div>' : "") + '<div class="layui-m-layermain" ' + (n.fixed ? "" : 'style="position:static;"') + '><div class="layui-m-layersection"><div class="layui-m-layerchild ' + (n.skin ? "layui-m-layer-" + n.skin + " " : "") + (n.className ? n.className : "") + " " + (n.anim ? "layui-m-anim-" + n.anim : "") + '" ' + (n.style ? 'style="' + n.style + '"' : "") + ">" + l + '<div class="layui-m-layercont">' + n.content + "</div>" + c + "</div></div></div>", !n.type || 2 === n.type) {
      var d = t[i](o[0] + n.type),
        y = d.length;
      y >= 1 && layer.close(d[0].getAttribute("index"))
    }
    document.body.appendChild(s);
    var u = e.elem = a("#" + e.id)[0];
    n.success && n.success(u), e.index = r++, e.action(n, u)
  }, c.prototype.action = function (e, t) {
    var n = this;
    e.time && (l.timer[n.index] = setTimeout(function () {
      layer.close(n.index)
    }, 1e3 * e.time));
    var a = function () {
      var t = this.getAttribute("type");
      0 == t ? (e.no && e.no(), layer.close(n.index)) : e.yes ? e.yes(n.index) : layer.close(n.index)
    };
    if (e.btn)
      for (var s = t[i]("layui-m-layerbtn")[0].children, r = s.length, o = 0; o < r; o++) l.touch(s[o], a);
    if (e.shade && e.shadeClose) {
      var c = t[i]("layui-m-layershade")[0];
      l.touch(c, function () {
        layer.close(n.index, e.end)
      })
    }
    e.end && (l.end[n.index] = e.end)
  }, e.layer = {
    v: "2.0",
    index: r,
    open: function (e) {
      var t = new c(e || {});
      return t.index
    },
    close: function (e) {
      var n = a("#" + o[0] + e)[0];
      n && (n.innerHTML = "", t.body.removeChild(n), clearTimeout(l.timer[e]), delete l.timer[e], "function" == typeof l.end[e] && l.end[e](), delete l.end[e])
    },
    closeAll: function () {
      for (var e = t[i](o[0]), n = 0, a = e.length; n < a; n++) layer.close(0 | e[0].getAttribute("index"))
    }
  }, "function" == typeof define ? define(function () {
    return layer
  }) : function () {
    var e = document.scripts,
      n = e[e.length - 1],
      i = n.src,
      a = i.substring(0, i.lastIndexOf("/") + 1);
    n.getAttribute("merge") || document.head.appendChild(function () {
      var e = t.createElement("link");
      return e.href = "/static/h5/css/need/layer.css", e.type = "text/css", e.rel = "styleSheet", e.id = "layermcss", e
    }())
  }()
}(window);

/**
 * url字符串转数组
 *
 * @param jsonStr: 要转换的json字符串
 */
function urlStrToArray(jsonStr) {
  var arr = new Array();
  for (var key in jsonStr) {
    arr.push(key + '=' + jsonStr[key]);
  }
  return arr;
}

/**
 * 请求参数加密
 *
 * @param dataList: 请求参数的一维数组
 * @returns: 包含加密后的一维数组
 **/
! function (n) {
  "use strict";

  function t(n, t) {
    var r = (65535 & n) + (65535 & t);
    return (n >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r
  }

  function r(n, t) {
    return n << t | n >>> 32 - t
  }

  function e(n, e, o, u, c, f) {
    return t(r(t(t(e, n), t(u, f)), c), o)
  }

  function o(n, t, r, o, u, c, f) {
    return e(t & r | ~t & o, n, t, u, c, f)
  }

  function u(n, t, r, o, u, c, f) {
    return e(t & o | r & ~o, n, t, u, c, f)
  }

  function c(n, t, r, o, u, c, f) {
    return e(t ^ r ^ o, n, t, u, c, f)
  }

  function f(n, t, r, o, u, c, f) {
    return e(r ^ (t | ~o), n, t, u, c, f)
  }

  function i(n, r) {
    n[r >> 5] |= 128 << r % 32, n[14 + (r + 64 >>> 9 << 4)] = r;
    var e, i, a, d, h, l = 1732584193,
      g = -271733879,
      v = -1732584194,
      m = 271733878;
    for (e = 0; e < n.length; e += 16) i = l, a = g, d = v, h = m, g = f(g = f(g = f(g = f(g = c(g = c(g = c(g = c(g = u(g = u(g = u(g = u(g = o(g = o(g = o(g = o(g, v = o(v, m = o(m, l = o(l, g, v, m, n[e], 7, -680876936), g, v, n[e + 1], 12, -389564586), l, g, n[e + 2], 17, 606105819), m, l, n[e + 3], 22, -1044525330), v = o(v, m = o(m, l = o(l, g, v, m, n[e + 4], 7, -176418897), g, v, n[e + 5], 12, 1200080426), l, g, n[e + 6], 17, -1473231341), m, l, n[e + 7], 22, -45705983), v = o(v, m = o(m, l = o(l, g, v, m, n[e + 8], 7, 1770035416), g, v, n[e + 9], 12, -1958414417), l, g, n[e + 10], 17, -42063), m, l, n[e + 11], 22, -1990404162), v = o(v, m = o(m, l = o(l, g, v, m, n[e + 12], 7, 1804603682), g, v, n[e + 13], 12, -40341101), l, g, n[e + 14], 17, -1502002290), m, l, n[e + 15], 22, 1236535329), v = u(v, m = u(m, l = u(l, g, v, m, n[e + 1], 5, -165796510), g, v, n[e + 6], 9, -1069501632), l, g, n[e + 11], 14, 643717713), m, l, n[e], 20, -373897302), v = u(v, m = u(m, l = u(l, g, v, m, n[e + 5], 5, -701558691), g, v, n[e + 10], 9, 38016083), l, g, n[e + 15], 14, -660478335), m, l, n[e + 4], 20, -405537848), v = u(v, m = u(m, l = u(l, g, v, m, n[e + 9], 5, 568446438), g, v, n[e + 14], 9, -1019803690), l, g, n[e + 3], 14, -187363961), m, l, n[e + 8], 20, 1163531501), v = u(v, m = u(m, l = u(l, g, v, m, n[e + 13], 5, -1444681467), g, v, n[e + 2], 9, -51403784), l, g, n[e + 7], 14, 1735328473), m, l, n[e + 12], 20, -1926607734), v = c(v, m = c(m, l = c(l, g, v, m, n[e + 5], 4, -378558), g, v, n[e + 8], 11, -2022574463), l, g, n[e + 11], 16, 1839030562), m, l, n[e + 14], 23, -35309556), v = c(v, m = c(m, l = c(l, g, v, m, n[e + 1], 4, -1530992060), g, v, n[e + 4], 11, 1272893353), l, g, n[e + 7], 16, -155497632), m, l, n[e + 10], 23, -1094730640), v = c(v, m = c(m, l = c(l, g, v, m, n[e + 13], 4, 681279174), g, v, n[e], 11, -358537222), l, g, n[e + 3], 16, -722521979), m, l, n[e + 6], 23, 76029189), v = c(v, m = c(m, l = c(l, g, v, m, n[e + 9], 4, -640364487), g, v, n[e + 12], 11, -421815835), l, g, n[e + 15], 16, 530742520), m, l, n[e + 2], 23, -995338651), v = f(v, m = f(m, l = f(l, g, v, m, n[e], 6, -198630844), g, v, n[e + 7], 10, 1126891415), l, g, n[e + 14], 15, -1416354905), m, l, n[e + 5], 21, -57434055), v = f(v, m = f(m, l = f(l, g, v, m, n[e + 12], 6, 1700485571), g, v, n[e + 3], 10, -1894986606), l, g, n[e + 10], 15, -1051523), m, l, n[e + 1], 21, -2054922799), v = f(v, m = f(m, l = f(l, g, v, m, n[e + 8], 6, 1873313359), g, v, n[e + 15], 10, -30611744), l, g, n[e + 6], 15, -1560198380), m, l, n[e + 13], 21, 1309151649), v = f(v, m = f(m, l = f(l, g, v, m, n[e + 4], 6, -145523070), g, v, n[e + 11], 10, -1120210379), l, g, n[e + 2], 15, 718787259), m, l, n[e + 9], 21, -343485551), l = t(l, i), g = t(g, a), v = t(v, d), m = t(m, h);
    return [l, g, v, m]
  }

  function a(n) {
    var t, r = "",
      e = 32 * n.length;
    for (t = 0; t < e; t += 8) r += String.fromCharCode(n[t >> 5] >>> t % 32 & 255);
    return r
  }

  function d(n) {
    var t, r = [];
    for (r[(n.length >> 2) - 1] = void 0, t = 0; t < r.length; t += 1) r[t] = 0;
    var e = 8 * n.length;
    for (t = 0; t < e; t += 8) r[t >> 5] |= (255 & n.charCodeAt(t / 8)) << t % 32;
    return r
  }

  function h(n) {
    return a(i(d(n), 8 * n.length))
  }

  function l(n, t) {
    var r, e, o = d(n),
      u = [],
      c = [];
    for (u[15] = c[15] = void 0, o.length > 16 && (o = i(o, 8 * n.length)), r = 0; r < 16; r += 1) u[r] = 909522486 ^ o[r], c[r] = 1549556828 ^ o[r];
    return e = i(u.concat(d(t)), 512 + 8 * t.length), a(i(c.concat(e), 640))
  }

  function g(n) {
    var t, r, e = "";
    for (r = 0; r < n.length; r += 1) t = n.charCodeAt(r), e += "0123456789abcdef".charAt(t >>> 4 & 15) + "0123456789abcdef".charAt(15 & t);
    return e
  }

  function v(n) {
    return unescape(encodeURIComponent(n))
  }

  function m(n) {
    return h(v(n))
  }

  function p(n) {
    return g(m(n))
  }

  function s(n, t) {
    return l(v(n), v(t))
  }

  function C(n, t) {
    return g(s(n, t))
  }

  function A(n, t, r) {
    return t ? r ? s(t, n) : C(t, n) : r ? m(n) : p(n)
  }

  "function" == typeof define && define.amd ? define(function () {
    return A
  }) : "object" == typeof module && module.exports ? module.exports = A : n.md5 = A
}(this);

function encryp(dataList) {
  var dataList_temp = {};
  for (var key in dataList) {
    // 只有值存在时才使用
    if (dataList[key] || dataList[key] === 0) {
      dataList_temp[key] = dataList[key];
    }
  }
  // 添加时间戳
  dataList_temp.random_str = "" + new Date().getTime();
  // 转换数组
  var arr = urlStrToArray(dataList_temp);
  // 参与数组排序
  arr.sort();
  // 将排序后的数组用连接符拼接成字符串并在结尾添加api密钥
  var urlparameter = arr.join('&') + '&key=56f9a73bbd386942a2d457e10276b814';
  // 进行md5加密
  var hash = md5(urlparameter);
  dataList_temp.sign = hash.toUpperCase();
  return dataList_temp;
}


window.textTip = function (str, t, callBack) {
  var late_t = t || 2000;
  var dom = document.createElement("p");
  dom.setAttribute('class', 'text-tip');
  document.body.appendChild(dom);
  var mytip = document.querySelector('.text-tip')

  mytip.style.display = "block";
  mytip.style.zIndex = 99;
  mytip.innerHTML = str;
  var tipHeight = mytip.offsetHeight;

  //文字两行或两行以上
  if ((tipHeight - 20) / 18 > 1) {
    mytip.style.width = "55%";
  }
  setTimeout(function () {
    mytip.style.display = "none";
    mytip.parentNode.removeChild(mytip);
    if (callBack) {
      callBack();
    }
  }, late_t);
}


window.getSystem = function () {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

  if (isAndroid) {
    return 'Android';
  } else if (isIOS) {
    return 'IOS';
  }
}

window.isIosorAndroid = function (data) {
  var dataString = JSON.stringify(data);
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  var iosdata = JSON.parse(dataString);
  if (isAndroid) {
    iosdata = JSON.stringify(iosdata);
    window.android.callAndroid(iosdata);
  } else if (isIOS) {
    void window.webkit.messageHandlers.callAndroid.postMessage(iosdata)
  }
  // console.log(iosdata)
}

window.ajax = function (type, url, data, callback, callbackComplete, loading, isQA) {
  // isQA 为true则请求财商圈子接口
  var params = encryp(data);
  var is_loading = loading || false;
  var load;
  var parmas_url = isQA ? process.env.API_ROOT_CS + url : process.env.API_ROOT + url;
  if (type == 'post') {
    params = JSON.stringify(params)
  }
  $.ajax({
    type: type,
    url: parmas_url,
    data: params,
    beforeSend: function () {
      load = is_loading ? Vue.prototype.$toast.loading({
        forbidClick: true
      }) : '';
    },
    success: function (data) {
      is_loading ? load.clear() : '';
      if (data.code === 200) {
        callback && callback(data)
      } else if (data.code === 279) {
        isIosorAndroid({
          "type": 1,
          "url": "",
          "title": "",
          "description": "",
          "imgUrl": "",
          "id": "",
          "name": ""
        });
      } else if (data.code === 285 && !isQA) {
        // textTip("答题异常，将在3秒后退出", 3000);
        Vue.prototype.$toast("答题异常，将在3秒后退出")
        isIosorAndroid({
          "type": 16,
          "answer_status": 2,
          "answer_reward_num": one_force,
          "url": "",
          "title": "",
          "description": "",
          "imgUrl": "",
          "id": "",
          "name": ""
        });
        setTimeout(function () {
          isIosorAndroid({
            "type": -1,
            "url": "",
            "title": "",
            "description": "",
            "imgUrl": "",
            "id": "",
            "name": ""
          });
        }, 3000)
      } else if (data.code === 286 && !isQA) {
        // textTip("答题太快，先休息一下吧~", 3000);
        Vue.prototype.$toast("答题太快，先休息一下吧~")
        callbackComplete && callbackComplete();
        return;
      } else if (data.code === 422) {
        callback && callback(data)
      } else {
        callbackComplete && callbackComplete();
        // textTip(data.msg, 2000);
        Vue.prototype.$toast(data.msg)
      }
    },
    error: function (err) {
      is_loading ? load.clear() : '';
      callbackComplete && callbackComplete(err);
      Vue.prototype.$toast(JSON.stringify(err) || '请求错误')
      // textTip(JSON.stringify(err) || '请求错误', 3000);
    },
    complete: function () {
      is_loading ? load.clear() : '';
      // callbackComplete && callbackComplete();
    }
  })
}

window.getAnswerVersion = (version) => {
  var get_system = getSystem();
  if (get_system == 'Android') {
    return version >= '1.7.24' ? true : false;
  } else if (get_system == 'IOS') {
    return version >= '1.7.18' ? true : false;
  }
}

window.goDownload = (waitTime) => {
  setTimeout(function () {
    window.location.href = "https://www.tuoluo.cn/download"
  }, waitTime)
}

//获取url地址栏参数
window.showWindowHref = () => {
  var sHref = window.location.href;
  if (sHref.indexOf('?') == -1) {
    return;
  } else {
    var args = sHref.split('?');
    var arr = args[1].split('&');
    var obj = {};
    for (var i = 0; i < arr.length; i++) {
      var arg = arr[i].split('=');
      obj[arg[0]] = arg[1];
    }
    return obj;
  }
}

//判断正式测试
window.getHost = (route) => {
  if (process.env.NODE_ENV == 'test') {
    return 'https://test-m.tuoluo.cn' + route;
  } else {
    return 'https://m.tuoluo.cn' + route;
  }
}

//判断付费文章正式测试
window.getHostPage = (route) => {
  if (process.env.NODE_ENV == 'test') {
    return 'https://share-test.tuoluo.net' + route;
  } else {
    return 'https://share.tuoluo.net' + route;
  }
}

//判断正式测试
window.getHostEstate = (route) => {
  if (process.env.NODE_ENV == 'test') {
    return 'https://test-app.tuoluo.cn/#' + route;
    // return 'http://192.168.1.82:6060/#' + route;
  } else {
    return 'https://app-h5.tuoluo.cn/#' + route;
  }
}



// WEBPACK FOOTER //
// ./src/plugin/ajax.js